import { useContext } from 'react';
import { Sidebar, SidebarLink, SidebarContext } from '@ka/webcomponents/nav';
import { KahlerLogo } from '../../common/KahlerLogo';
import { useKaEmployee } from '../../userAccess/kaEmployee/useKaEmployee';

const EmployeeLinks = () => {
  const kaEmployee = useKaEmployee();

  return <>
    {kaEmployee.canViewOrders && <SidebarLink to="/dashboard" icon="file-ruled" label="Order Dashboard" />}
    <SidebarLink to="/sites" icon="geo-alt" label="Manage Sites" />
  </>;
};

export function KAEmployeeNavSideMenu() {
  const { isCollapsed, toggleSidebar } = useContext(SidebarContext);

  return (
    <Sidebar
      collapsed={isCollapsed}
      onToggle={toggleSidebar}
      footer={<KahlerLogo isCollapsed={isCollapsed} />}>
      <EmployeeLinks />
    </Sidebar>
  );
}
